﻿"use strict";

const subNav = {
  init: function() {
    this.subNav = document.querySelector("#subnav");

    if (this.subNav === null) {
      return;
    }

    this.subNavItem = this.subNav.querySelectorAll(".subnav__list--item");
    this.subNavList = this.subNav.querySelector("#subnav__list ");
    this.subNavIcon = this.subNav.querySelector("#subnav-icon");

    this.events();
  },

  events: function() {
    this.subNav.addEventListener("click", () => {
      this.toggleSubNav();
    });
  },

  toggleSubNav: function() {
    if (window.innerWidth < 992) {
      this.subNav.classList.toggle("show");

      for (var x = 0; x < this.subNavItem.length; x++) {
        var subHeightCalc = this.subNavItem.length * 4.0625;
      }

      if (this.subNav.classList.contains("show")) {
        this.subNav.style.height = subHeightCalc + "rem";
      } else {
        this.subNav.style.height = "4.0625rem";
      }
    }
  }
};

export default subNav.init();
